var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Notification'),_c('router-view'),_c('BulkDialog'),_c('DeleteDialog'),_c('RefetchStatsDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }